export { StorageClient } from './StorageClient';
export { default as StorageAnalyticsClient } from './packages/StorageAnalyticsClient';
export * from './lib/types';
export * from './lib/errors';
export * from './lib/vectors';
//# sourceMappingURL=index.js.map